<div ngpDialogOverlay [class]="overlayClasses">
  <div ngpDialog [class]="contentClasses">
    <div class="flex w-full justify-end">
      <ml-icon name="close" size="sm" (click)="closeDialog()" class="cursor-pointer" />
    </div>
    <h2 ngpDialogTitle [class]="titleClasses">
      <ng-content select="[dialogTitle]"></ng-content>
    </h2>
    <p ngpDialogDescription [class]="descriptionClasses">
      <ng-content select="[dialogDescription]"></ng-content>
    </p>
    <ng-content></ng-content>
  </div>
</div>
